/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */
const Wrapper = styled.div`
  position: absolute;
  padding: 32px 0;
  z-index: 3;
`;
const Container = styled.div`
  max-width: 450px;
  margin: 0 auto;
  padding: ${t.grid.space1} ${t.grid.space2};
  text-align: center;
  font-family: ${t.font.primary};
  box-shadow: 0px 2px 16px 0 rgba(0, 0, 0, 0.42);
  color: ${t.color.red};
  background-color: ${t.color.white};
`;

/**
 * error component is..
 */

const Content__error = ({ content, className }) => (
  <Wrapper className={className}>
    <Container>{content}</Container>
  </Wrapper>
);

export default Content__error;

Content__error.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Content__error.defaultProps = {
  style: {},
};

/*
    import Content__error from 'components/content/error/content__error'
    <Content__error />
  */
